import React, { Component } from "react";
import { MDBContainer, MDBNavbar, MDBNavbarBrand, MDBNavbarToggler, MDBCollapse, MDBNavbarNav, MDBNavLink, MDBNavItem, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBTypo } from "mdbreact";
import { Typography } from "@material-ui/core";

import logo from "../images/logo.png";

class NavBar extends Component {
    state = {
        isOpen: false
      };
      
      toggleCollapse = () => {
        this.setState({ isOpen: !this.state.isOpen });
      }
      

render() {
    return (
        <MDBNavbar color="peach-gradient" dark scrolling fixed="top" expand="md" style={{'padding-bottom':'7px', 'padding-top':'7px'}}>
            <MDBContainer>
                <MDBNavbarBrand href='/'>
                </MDBNavbarBrand>
                <MDBNavbarToggler onClick={this.toggleCollapse} />
                <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>
                <MDBNavbarNav right style={{'padding-top':'10px'}}>
                    <MDBNavItem>
                        <MDBDropdown>
                            <MDBDropdownToggle nav caret>
                                <span className="mr-2">Signwriter</span>
                            </MDBDropdownToggle>
                            <MDBDropdownMenu >
                                <MDBNavLink to="/signwriter"><MDBTypo colorText="black">Signage - Home</MDBTypo></MDBNavLink>
                                <MDBDropdownItem divider />
                                <MDBNavLink to="/signwriter/business-branding"><MDBTypo colorText="black">Business Branding</MDBTypo></MDBNavLink>
                                <MDBNavLink to="/signwriter/custom-artistic"><MDBTypo colorText="black">Custom Artistic</MDBTypo></MDBNavLink>
                                <MDBNavLink to="/signwriter/Lettering-and-illumination"><MDBTypo colorText="black">3D Lettering and Illuminated</MDBTypo></MDBNavLink>
                                <MDBNavLink to="/signwriter/exterior"><MDBTypo colorText="black">Exterior Signs</MDBTypo></MDBNavLink>
                                <MDBNavLink to="/signwriter/interior"><MDBTypo colorText="black">Interior Signs</MDBTypo></MDBNavLink>
                                <MDBNavLink to="/signwriter/vehicle"><MDBTypo colorText="black">Vehicle Signs</MDBTypo></MDBNavLink>
                                <MDBNavLink to="/signwriter/design-service"><MDBTypo colorText="black">Design Service</MDBTypo></MDBNavLink>
                                <MDBNavLink to="/signwriter/service-areas"><MDBTypo colorText="black">Service Areas</MDBTypo></MDBNavLink>
                            </MDBDropdownMenu>
                        </MDBDropdown>
                    </MDBNavItem>
                    <MDBNavItem>
                        <MDBNavLink to="/artist"><MDBTypo>Artist</MDBTypo></MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                        <MDBNavLink to="/songwriter"><MDBTypo>Songwriter</MDBTypo></MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                        <MDBNavLink to="/musician"><MDBTypo>Musician</MDBTypo></MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                        <MDBNavLink to="/about"><MDBTypo>About</MDBTypo></MDBNavLink>
                    </MDBNavItem>
                    <MDBNavItem>
                        <MDBNavLink to="/contact"><MDBTypo>Contact</MDBTypo></MDBNavLink>
                    </MDBNavItem>
                </MDBNavbarNav>
                </MDBCollapse>
            </MDBContainer>
        </MDBNavbar>
    );
}
}

export default NavBar;